import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './quasar'
import VueI18n from 'vue-i18n'
import globalText from "@/assets/globalText.js"

const messages = globalText
Vue.use(VueI18n)

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'de', // set locale
  messages // set locale messages
})

import moment from 'moment'
Vue.prototype.moment = moment

//import Plugin from '@quasar/quasar-ui-qcalendar'
//import '@quasar/quasar-ui-qcalendar/dist/index.css'
//Vue.use(Plugin)

import DateInput from './components/InputDate'

import './registerServiceWorker'
Vue.component('DateInput', DateInput)

var org = 4 // 0 = Developpment, 1 = Insafety, 2 = Rastrealo, 3 = Infinitrack, 4 = GpsTurix
Vue.prototype.$versionText = 'MTracking Version 1.32'

//Set Global
if(org == 0){
  Vue.prototype.$apiUrl = 'http://192.168.0.155/GpsTracking/api/MTracking'
  Vue.prototype.$apiUrlGo = 'http://192.168.0.155:9001'
  Vue.prototype.$copyRight = '2023 Insafety GmbH, Zürich, Switzerland'
  Vue.prototype.$appTitle = 'Trackportal Developpment'
  Vue.prototype.$org = 0
}
if(org == 1){
  Vue.prototype.$apiUrl = 'https://track.insafety.ch/api/MTracking'
  Vue.prototype.$apiUrlGo = 'https://mtrack.insafety.ch:9001'
  Vue.prototype.$copyRight = '2019 Insafety GmbH, Zürich, Switzerland'
  Vue.prototype.$appTitle = 'Trackportal by Insafety GmbH, Switzerland'
  Vue.prototype.$org = 1
}
if(org == 2){
  Vue.prototype.$apiUrl =   'https://admin.rastrealo.com/api/MTracking'
  Vue.prototype.$apiUrlGo = 'https://mcontrol.rastrealo.com:9001'  
  Vue.prototype.$copyRight = '2019 MAS QUE GPS S DE RL DE CV'
  Vue.prototype.$appTitle = 'Rastrealo.com'
  Vue.prototype.$org = 2
}
if(org == 3){
  Vue.prototype.$apiUrl = 'https://track.insafety.ch/api/MTracking'
  Vue.prototype.$apiUrlGo = 'https://mtrack.insafety.ch:9001'
  Vue.prototype.$copyRight = '2019 Infinitrack SA, Bangkok, Thailand'
  Vue.prototype.$appTitle = 'Infinitrack SA, Thailand'
  Vue.prototype.$org = 3
}

if(org == 4){
  Vue.prototype.$apiUrl =   'https://admin.gpsturix.com/api/MTracking'
  Vue.prototype.$apiUrlGo = 'https://control.gpsturix.com:9001'  
  Vue.prototype.$copyRight = '2023 MAS QUE GPS S DE RL DE CV'
  Vue.prototype.$appTitle = 'gpsturix.com'
  Vue.prototype.$org = 4
}

var url = window.location.origin
if (url.includes('rackmount-ug.com')){
  Vue.prototype.$appTitle = 'Rackmount Technologies'
}


Vue.config.productionTip = false
export const eventBus = new Vue()  //set up our global eventBus BEFORE the main vue instance

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
